import { FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';
import { logout } from '../services/auth.service';

export const LogoutPage: FunctionComponent<RoutableProps> = () => {
  useEffect(() => {
    logout().finally(() => route('/login', true));
  }, []);

  return (
    <Layout title="Abmelden">
      <div class="center mt-lg muted">Sitzung wird beendet …</div>
    </Layout>
  );
};
